module.exports = __webpack_public_path__ + "static/img/bg-thankyou-full.9b74c3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-thankyou-full.jpg
// module id = 662
// module chunks = 1